import React, { useState } from 'react';
import clsx from 'clsx';
import NegotiationListingsEmptyState from '@components/organisms/negotiation-listings/empty-state/negotiation-listings-empty-state';
import { useListItemSelectContext } from '@context/negotiation-listings-split-view.context';
import ToastMessage from '@components/atoms/toast-message/toast-message';
import { useSellingOffers } from '@context/selling-offers.context';
// import { useOfferStatusSubscription } from '@hooks/negotiations/useOfferStatusSubscription';
// import {
//   mapNegotiationToSellingOfferProductsItem,
//   mapNegotiationToSellingOfferNegotiationData,
// } from '@interfaces/models/negotiation/mappers/sellingOffersProductsMapper';
// import { Negotiation } from '@interfaces/models/negotiation/negotiation';
// import { SellingOffersProductsItem } from '@interfaces/models/negotiation/domain/SellingOffersProduct';
// import { SellingOffersNegotiationData } from '@interfaces/models/negotiation/domain/SellingOffersNegotiation';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import NegotiationListingsErrorState from '../negotiation-listings/error-state/negotiation-listings-error-state';
import SellingOffersProductsColumn from './selling-offers-products-column/selling-offers-products-column';
import SellingOffersNegotiationsColumn from './selling-offers-negotiations-column/selling-offers-negotiations-column';
import { useSellingOffersPresenter } from './selling-offers-presenter';
import styles from './selling-offers.module.scss';
import SellingOffersParamDialog from './selling-offers-param-dialog/selling-offers-param-dialog';

const SellingOffers: React.FC = () => {
  const { t } = useTranslation('negotiation');
  const { selectedListItemId, hasNegotiationColumnError } = useListItemSelectContext();
  const {
    sellingOffersProductsList,
    sellingOffersProductsPaginationMeta,
    // setSellingOffersProductsList,
    sellingOffersNegotiationsList,
    sellingOffersNegotiationsPaginationMeta,
    setSellingOffersNegotiationsList,
  } = useSellingOffers();
  const { isLoading, isFetching, error } = useSellingOffersPresenter(sellingOffersProductsPaginationMeta);
  const router = useRouter();
  const [negotiationId, setNegotiationId] = useState<string | null>((router?.query?.negotiation_id as string) || null);
  const [hasPopupNegotiationError, setHasPopupNegotiationError] = useState<boolean>(false);

  // TODO: to be confirmed
  // useOfferStatusSubscription<SellingOffersProductsItem>(sellingOffersProductsList, setSellingOffersProductsList, {
  //   mapCheck: (negotiation: Negotiation, listItem: SellingOffersProductsItem) =>
  //     String(listItem.product.id) === String(negotiation.product?.id),
  //   mapFunction: (negotiation: Negotiation, listItem: SellingOffersProductsItem) =>
  //     mapNegotiationToSellingOfferProductsItem(negotiation, listItem),
  // });

  // useOfferStatusSubscription<SellingOffersNegotiationData>(
  //   sellingOffersNegotiationsList,
  //   setSellingOffersNegotiationsList,
  //   {
  //     mapCheck: (negotiation: Negotiation, listItem: SellingOffersNegotiationData) =>
  //       String(listItem.id) === String(negotiation.id),
  //     mapFunction: (negotiation: Negotiation, listItem: SellingOffersNegotiationData) =>
  //       mapNegotiationToSellingOfferNegotiationData(negotiation, listItem),
  //   },
  // );

  if (error) {
    return <NegotiationListingsErrorState />;
  }

  if (!isLoading && !isFetching && (!sellingOffersProductsList || !sellingOffersProductsList.length)) {
    return <NegotiationListingsEmptyState type="selling" />;
  }

  return (
    <div
      className={clsx(
        styles.sellingOffers__wrapper,
        selectedListItemId && styles['sellingOffers__wrapper--display-negotiations'],
      )}
    >
      {negotiationId && (
        <SellingOffersParamDialog
          negotiationId={negotiationId}
          setNegotiationId={setNegotiationId}
          setHasPopupNegotiationError={setHasPopupNegotiationError}
        />
      )}
      <SellingOffersProductsColumn
        sellingOffersProductsList={sellingOffersProductsList}
        sellingOffersProductsPaginationMeta={sellingOffersProductsPaginationMeta}
      />
      <SellingOffersNegotiationsColumn
        sellingOffersNegotiationsPaginationMeta={sellingOffersNegotiationsPaginationMeta}
        setSellingOffersNegotiationsList={setSellingOffersNegotiationsList}
        sellingOffersNegotiationsList={sellingOffersNegotiationsList}
      />
      <ToastMessage
        key="sellingOffersErrorToast"
        id="sellingOffersErrorToast"
        className={styles.sellingOffers__toast}
        title={t('NEGOTIATION_LISTING.SELLING_OFFERS.ERROR_TOAST')}
        subtitle=" "
        show={hasNegotiationColumnError || hasPopupNegotiationError}
        icon="warning-default"
        duration={5000}
        type="error"
      />
    </div>
  );
};

export default SellingOffers;
